<template>
  <div>
    <imgHeader imgUrl="/img/11招商加盟-banner.jpg" />
    <div class="w main">
      <h3 class="title" style="text-align: center">招商加盟</h3>
      <div class="line line1"></div>
      <div class="container flex">
        <div class="card" v-for="item in list" :key="item.title">
          <div>
            <div class="card-img">
              <img :src="item.imgUrl" alt="" />
            </div>
            <div class="card-title">
              <span>{{ item.title }}</span>
            </div>
            <div class="card-desc">
              <p>
                {{ item.desc }}
              </p>
            </div>
            <div class="card-footer flex">
              <div class="join" @click="toDialog">立即加入</div>
            </div>
          </div>
          <div class="dark">
            <div class="dark-box">
              <div>
                <span class="dark-box-title">负责人：</span>
                <span>林经理</span>
              </div>
              <div>
                <span class="dark-box-title">电话：</span>
                <span>400-0000-0000</span>
              </div>
              <div>
                <span class="dark-box-title">在线联系：</span>
                <span class="dark-box-lx">
                  <img
                    src="/img/wx.png"
                    alt=""
                    style="margin-right: 5px;"
                  />linjingli</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <dialog_investment :dialogVisible.sync="dialogVisible"></dialog_investment>
  </div>
</template>

<script>
  import dialog_investment from '../components/dialog_investment.vue'
  export default {
    name: 'Investment',
    components: { dialog_investment },
    data() {
      return {
        list: [
          {
            title: '招商计划1',
            imgUrl: require('/public/img/11招商加盟-img1_03.png'),
            desc:
              '招商加盟政策内容招商加盟政策内容招商加盟政策内容招商加盟政策内容招商加盟政策内容招商加盟政策内容招商加盟政策内容招商加盟政策内容招商加盟政策内容',
          },
          {
            title: '招商计划2',
            imgUrl: require('/public/img/11招商加盟-img2_03.png'),
            desc:
              '招商加盟政策内容招商加盟政策内容招商加盟政策内容招商加盟政策内容招商加盟政策内容招商加盟政策内容招商加盟政策内容招商加盟政策内容招商加盟政策内容',
          },
          {
            title: '招商计划3',
            imgUrl: require('/public/img/11招商加盟-img3_03.png'),
            desc:
              '招商加盟政策内容招商加盟政策内容招商加盟政策内容招商加盟政策内容招商加盟政策内容招商加盟政策内容招商加盟政策内容招商加盟政策内容招商加盟政策内容',
          },
        ],
        dialogVisible: false,
      }
    },
    methods: {
      toDialog() {
        this.dialogVisible = true
      },
    },
  }
</script>

<style scoped lang="scss">
  .main {
    margin-bottom: 90px;
  }
  .container {
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 60px;
  }
  .card {
    position: relative;
    width: 445px;
    border-radius: 10px;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    &:hover {
      transform: scale(1.04);
      .join {
        background-color: var(--font-color);
        color: #fff;
      }
      .dark {
        width: 100%;
        transition: transform 1s;
        transform: rotateY(0deg);
      }
      .dark-box {
        display: block;
      }
    }
  }
  .dark {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    width: 0px;
    top: 0;
    bottom: 0;
    transform: rotateY(90deg);
    background-color: rgba(0, 0, 0, 0.4);
  }
  .dark-box {
    display: none;
    padding: 30px 20px;
    border-radius: 10px;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.5);
    span {
      line-height: 1.5;
    }
  }
  .dark-box-title {
    display: inline-block;
    width: 80px;
  }

  .card-img {
    font-size: 0;

    img {
      width: 100%;
      height: 326px;
    }
  }
  .card-title {
    text-align: center;
    padding: 10px 20px;
    span {
      font-size: 18px;
      font-weight: bold;
    }
  }
  .card-desc,
  .card-footer {
    padding: 0 20px;
  }
  .card-desc {
    margin-bottom: 20px;
    font-size: 14px;
    color: #333;
    p {
      margin: 0;
      line-height: 1.8;
    }
  }
  .card-footer {
    padding: 0 20px 20px;
    flex-direction: row-reverse;
  }
  .join {
    z-index: 2;
    padding: 5px 10px;
    border: 1px solid var(--font-color);
    border-radius: 20px;
    font-size: 14px;
    color: var(--font-color);
    cursor: pointer;
    &:active {
      transform: scale(0.98);
    }
  }
</style>
